import {Validators} from '@angular/forms';

import {ComponentTypesEnum} from '../../../app/shared/enums';
import {BaseControl, SelectControl} from '../../../app/shared/classes';
import {
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableData,
    ReportTableDataRow
} from '../../../app/shared/components';

export const SourceOfIncomeIdSelector = 'sourceOfFundId';
export const SourceOfIncomeEmploymentStatusSelector = 'employmentStatus';
export const SourceOfIncomeBusinessSelector = 'business';

export const SourceOfIncomePartSelector = 'sourceOfIncomePart';
export const SourceOfIncomeTypeSelector = 'sourceOfIncomeType';
export const SourceOfIncomeRiskScoreSelector = 'sourceOfIncomeRiskScore';
export const SourceOfIncomeRiskLevelSelector = 'sourceOfIncomeRiskLevel';

export const SourceOfIncomesFormArraySelector = 'sourceOfIncomesFormArray';

export const SourceOfIncomeControls = (): BaseControl<string | number>[] => {
    return [
        new BaseControl({
            name: SourceOfIncomeIdSelector,
            value: null,
            placeholder: '',
            validators: [],
            componentType: ComponentTypesEnum.Text
        }),
        new SelectControl({
            name: SourceOfIncomeEmploymentStatusSelector,
            value: null,
            placeholder: 'Employment status',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        }),
        new SelectControl({
            name: SourceOfIncomeBusinessSelector,
            value: null,
            placeholder: 'Industry',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        })
    ];
};

export const SourceOfIncomeDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [
            new ReportTableDataRow({
                rowId: SourceOfIncomeEmploymentStatusSelector,
                dataItems: [
                    new ReportTableData<string>({
                        colId: SourceOfIncomePartSelector,
                        value: 'Employment status',
                        hidden: false
                    }),
                    new ReportTableData<string>({
                        colId: SourceOfIncomeTypeSelector,
                        value: null,
                        hidden: false
                    }),
                    new ReportTableData<number>({
                        colId: SourceOfIncomeRiskScoreSelector,
                        value: null,
                        hidden: false,
                    }),
                    new ReportTableData<number>({
                        colId: SourceOfIncomeRiskLevelSelector,
                        value: null,
                        hidden: false
                    }),
                ]
            }),
            new ReportTableDataRow({
                rowId: SourceOfIncomeBusinessSelector,
                dataItems: [
                    new ReportTableData<string>({
                        colId: SourceOfIncomePartSelector,
                        value: 'Industry',
                        hidden: false
                    }),
                    new ReportTableData<string>({
                        colId: SourceOfIncomeTypeSelector,
                        value: null,
                        hidden: false
                    }),
                    new ReportTableData<number>({
                        colId: SourceOfIncomeRiskScoreSelector,
                        value: null,
                        hidden: false,
                    }),
                    new ReportTableData<number>({
                        colId: SourceOfIncomeRiskLevelSelector,
                        value: null,
                        hidden: false
                    }),
                ]
            })
        ],
        columns: [
            new ReportTableColumn({
                label: '',
                selector: SourceOfIncomePartSelector
            }),
            new ReportTableColumn({
                label: 'Type',
                selector: SourceOfIncomeTypeSelector
            }),
            new ReportTableColumn({
                label: 'Risk score',
                selector: SourceOfIncomeRiskScoreSelector
            }),
            new ReportTableColumn({
                label: 'Risk level',
                selector: SourceOfIncomeRiskLevelSelector
            }),
        ],
        hiddenColumnIds: [],
        actionMenu: false,
        disableColumnsOptions: true
    };
};
